/**
 * @(#)2019/7/12.
 * EMail，用于邮箱验证
 * @author 许许
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import Basics from "./Basics";
import { cloneDeep } from "../../utils";
import React, { Component } from "react";
import { l } from "../../config/language";
import { YxComponent, Connection } from "../YxComponent";
import { IEmailPropTypes } from "./IpropType/emailPropType";
/*
 * @param children {ReactNode} react节点
 * @param styleParam {object} 样式参数
 * @param styleParam.width {object} 宽度  xxs,xs,sm,md,lg,xl
 * */

//默认props
let defaul = () => {
  return {
    rules: {},
    inputParam: {},
    children: "",
    styleParam: {
      width: "sm", //宽度  xxs,xs,sm,md,lg,xl
      size: "default", //大小
      type: "default", //类型
    },
  };
};
@Connection(defaul)
class EMail extends YxComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static ident = "YxInput.EMail";

  productionHtml() {
    let tmpProps = { ...this.props };
    // tmpProps.rules = (tmpProps.rules)
    tmpProps.rules.eMailCheck = {
      //规则：以数字字母开头、中间可以是多个数字、字母、下划线或“-”，然后是“@”符号，h后面是数字字母，然后是“，”符号，加2-4个字母结尾
      pattern: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
      message: l("Email.ecm"),
    };

    let classParam = {
      yx_yxInput_: "styleParam.type",
      yx_yxInput_width_: "styleParam.width",
      yx_yxInput_size_: "styleParam.size",
    };
    tmpProps.inputParam.className = this.styleParamClassName(
      tmpProps,
      classParam
    );

    let html = Basics.html(tmpProps);
    return html;
  }

  render() {
    //合并默认参数和外部参数
    return <div className="yx_yxInput_eMail">{this.productionHtml()}</div>;
  }
}

EMail.propTypes = IEmailPropTypes;
EMail.defaultProps = defaul();
export default EMail;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/EMail.js